import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import clasol from '../../media/logo.png';

export const LoginBrandPanel = () => {
    return (
        <Box
            sx={{
                position: 'relative',
                overflow: 'hidden',
                minHeight: { xs: 172, sm: 188, md: '100vh' },
                bgcolor: 'secondary.main',
                color: 'secondary.contrastText',
                display: 'flex',
                alignItems: 'center',
                px: { xs: 2, sm: 3, md: 5 },
                py: { xs: 2, sm: 2.5, md: 6 },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    right: { xs: -78, md: -90 },
                    bottom: { xs: -132, md: -110 },
                    width: { xs: 220, md: 260 },
                    height: { xs: 220, md: 260 },
                    borderRadius: '50%',
                    background: 'rgba(255, 121, 0, 0.18)',
                },
            }}
        >
            <Stack
                spacing={{ xs: 2, md: 3 }}
                direction={{ xs: 'row', md: 'column' }}
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    width: '100%',
                    minWidth: 0,
                    alignItems: { xs: 'center', md: 'flex-start' },
                }}
            >
                <Box
                    sx={{
                        flex: '0 0 auto',
                        width: { xs: 88, sm: 104, md: 152 },
                    }}
                >
                    <img src={clasol} alt="Logo" style={{ width: '100%' }} />
                </Box>

                <Box>
                    <Typography
                        component="p"
                        sx={{
                            color: 'primary.main',
                            fontWeight: 900,
                            fontSize: { xs: 13, sm: 15, md: 18 },
                            lineHeight: { xs: '16px', sm: '18px', md: '22px' },
                        }}
                    >
                        SUITE - FLUJOS
                    </Typography>
                    <Typography
                        variant="h1"
                        sx={{
                            mt: { xs: 1, md: 2 },
                            maxWidth: 380,
                            color: '#ffffff',
                            fontSize: { xs: 22, sm: 24, md: 28 },
                            lineHeight: { xs: '28px', sm: '30px', md: '36px' },
                        }}
                    >
                        Control de flujos de fruta
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            mt: 1,
                            maxWidth: 420,
                            color: 'rgba(255,255,255,0.72)',
                        }}
                    >
                        Acceso operativo para registrar y consultar movimientos internos de fruta.
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        mt: { xs: 1, md: 7 },
                        pt: 2,
                        borderTop: '1px solid rgba(255,255,255,0.12)',
                        color: 'rgba(255,255,255,0.58)',
                        fontSize: 12,
                    }}
                >
                    Version 0.0.1
                </Box>
            </Stack>
        </Box>
    );
};
